import { FC, PropsWithChildren } from 'react'
import { ArpMediaFilters, DEFAULT_SONGS_FILTERS, useArpTable } from '../hooks'
import { ArpTableContext } from './ArpTableContext'

type RootProps = PropsWithChildren<{ defaultFilters?: ArpMediaFilters }>
export const Root: FC<RootProps> = ({ children, defaultFilters = DEFAULT_SONGS_FILTERS }) => {
  const contextData = useArpTable(defaultFilters)
  return <ArpTableContext.Provider value={contextData}>{children}</ArpTableContext.Provider>
}
